import { Box, styled } from '@mui/material';

/**
 * The card's list item.
 *
 * Sits above the slots (`z-index: 1`) so a click on a card edge hits the card,
 * not the slot reaching under it with its negative margin. The same holds
 * during a drag: the card wins the overlap and resolves it to the very slot
 * that reaches into it, so the overlap behaves as before and the rest of the
 * card — dead until the card became a drop target — behaves the same way.
 */
export const CardListItem = styled(Box)({
  position: 'relative',
  zIndex: 2,
  '+ * .activity-card': {
    marginTop: '8px'
  }
}) as typeof Box;

/** Spacing between stacked cards, inside the list item's own box. */
export const CardContainer = styled(Box)({
  marginTop: '8px'
}) as typeof Box;
